import { PageWrapper } from '../../../CommonComponents/PageWrapper/PageWrapper';
import styled from '../../../theme/theme';

export const StyledPageWrapper = styled(PageWrapper)(({ theme }) => ({
  margin: 0,
  padding: 0,
  display: 'flex',
  flexDirection: 'column',
  gap: theme.space[24],
}));
